import { useCallback, useState } from "react";

// Define a type for the form data structure
type FormDataType = Record<any, any>; 
interface UseHandleChangeHooksReturn {
  formData?: FormDataType | undefined | any;
  setFormData: React.Dispatch<React.SetStateAction<FormDataType>>;
  handleChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  submit: boolean;
  setSubmit: React.Dispatch<React.SetStateAction<boolean>>;
}

const useHandleChangeHooks = (initialState: FormDataType): UseHandleChangeHooksReturn => {
  const [formData, setFormData] = useState<FormDataType>(initialState);
  const [submit, setSubmit] = useState<boolean>(false);

  const handleChange = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value, type, files } = e.target;
    if (type === "file" && files) {
     
      setFormData((prevFormData) => ({
        ...prevFormData,
        [name]: files[0],
      }));
    } else {
      setFormData((prevFormData) => ({
        ...prevFormData,
        [name]: value,
      }));
    }
  }, []);

  return { formData, setFormData, handleChange, submit, setSubmit };
};

export default useHandleChangeHooks;
